import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Reveal from "./Reveal";

const TESTIMONIALS = [
  {
    quote:
      "Trust Flooring delivered a clean, consistent finish across every unit on programme. Communication was excellent.",
    name: "Project Manager",
    role: "Auckland Residential Developer",
  },
  {
    quote:
      "Having one team coordinate flooring, plastering and tiling removed weeks of friction from our build schedule.",
    name: "Senior Site Manager",
    role: "Commercial Construction",
  },
  {
    quote:
      "The artisan plaster and microcement work was outstanding. A real point of difference on the build.",
    name: "Architect",
    role: "Boutique Residential Practice",
  },
  {
    quote:
      "Reliable, professional and easy to work with. A permanent spot on our subbie list.",
    name: "Builder",
    role: "Christchurch Residential",
  },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const total = TESTIMONIALS.length;
  const t = TESTIMONIALS[index];

  const prev = () => setIndex((i) => (i - 1 + total) % total);
  const next = () => setIndex((i) => (i + 1) % total);

  return (
    <section
      className="py-32 md:py-48 border-t border-[#E2E2DF]"
      data-testid="testimonials-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <Reveal>
          <span className="eyebrow">Client Stories</span>
        </Reveal>
        <Reveal delay={100}>
          <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
            <div className="md:col-span-9">
              <blockquote
                key={index}
                data-testid={`testimonial-${index}`}
                className="font-heading text-xl md:text-2xl lg:text-3xl leading-[1.35] text-[#111111] font-normal max-w-3xl reveal"
              >
                "{t.quote}"
              </blockquote>
              <div className="mt-12 flex items-baseline justify-between gap-6 border-t border-[#E2E2DF] pt-6 max-w-3xl">
                <div>
                  <p className="font-heading text-sm text-[#111111]">
                    {t.name}
                  </p>
                  <p className="text-[#545454] text-xs mt-1">{t.role}</p>
                </div>
                <p className="font-heading text-[10px] uppercase tracking-[0.25em] text-[#545454]">
                  {String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
                </p>
              </div>
            </div>
            <div className="md:col-span-3 flex md:flex-col gap-3 md:items-end mt-6 md:mt-0">
              <button
                onClick={prev}
                aria-label="Previous testimonial"
                data-testid="testimonial-prev"
                className="w-10 h-10 border border-[#E2E2DF] flex items-center justify-center text-[#111111] hover:border-[#EB1D25] hover:text-[#EB1D25] transition-colors"
              >
                <ChevronLeft size={16} strokeWidth={1.5} />
              </button>
              <button
                onClick={next}
                aria-label="Next testimonial"
                data-testid="testimonial-next"
                className="w-10 h-10 border border-[#E2E2DF] flex items-center justify-center text-[#111111] hover:border-[#EB1D25] hover:text-[#EB1D25] transition-colors"
              >
                <ChevronRight size={16} strokeWidth={1.5} />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
